import { diContainer } from '../../../libs/container';
import { LocalStorage, NAVIGATION_DROPDOWN_STATES } from '../../../util/LocalStorage';
import { IDropdownStorageState, INavigationItem } from './navigation.slice';
import { Feature } from '@cyberlabrs/helpers';

const localStorage = diContainer.get(LocalStorage);
const storageState = localStorage.get(NAVIGATION_DROPDOWN_STATES);

const DEFAULT_OWNER_STORAGE_DROPDOWN: IDropdownStorageState = {
    ptoAndLeave: false,
    settings: false,
    performance: false,
    reports: false,
};

const parsedStorageState: IDropdownStorageState = storageState ? JSON.parse(storageState) : DEFAULT_OWNER_STORAGE_DROPDOWN;

const isLargeScreen = window.screen.width >= 992;

export const OWNER_NAVIGATION: INavigationItem[] = [
    {
        keyTitle: 'dashboard',
        url: '/',
        icon: '/svg/sidebar/dashboard.svg',
        activeIcon: '/svg/sidebar/dashboard-bold.svg',
        iconAlt: 'Dashboard',
        subMenuItems: [],
        hasParams: false,
        sectionTitle: '',
        disabled: false,
    },
    {
        keyTitle: 'timeTracking',
        url: '/time-tracking',
        icon: '/svg/sidebar/timer-start.svg',
        activeIcon: '/svg/sidebar/timer-start-bold.svg',
        iconAlt: 'Clock',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: '',
        disabled: false,
    },
    {
        keyTitle: 'ptoAndLeave',
        url: '',
        icon: '/svg/sidebar/leave-request.svg',
        activeIcon: '/svg/sidebar/leave-request-bold.svg',
        iconAlt: 'Calendar',
        subMenuItems: [
            {
                keyTitle: 'myBalance',
                url: '/my-balance',
                hasParams: false,
            },
            {
                keyTitle: 'leaveRequests',
                url: '/leave-request/owner',
                hasParams: false,
            },
            {
                keyTitle: 'calendar',
                url: '/calendar',
                hasParams: false,
            },
            {
                keyTitle: 'holidays',
                url: '/holidays',
                hasParams: false,
                disabled: false,
                featureName: Feature.HOLIDAYS,
            },
        ],
        hasParams: false,
        sectionTitle: '',
        disabled: false,
        showDropdown: parsedStorageState['ptoAndLeave'],
    },
    {
        keyTitle: 'projects',
        url: '/projects',
        icon: '/svg/sidebar/projects.svg',
        activeIcon: '/svg/sidebar/projects-bold.svg',
        iconAlt: 'Projects',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'manage',
        disabled: false,
    },
    {
        keyTitle: 'clients',
        url: '/clients',
        icon: '/svg/sidebar/clients.svg',
        activeIcon: '/svg/sidebar/clients-bold.svg',
        iconAlt: 'Suitcase',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'manage',
        disabled: false,
    },
    {
        keyTitle: 'invoicing',
        url: isLargeScreen ? '/invoices' : '/invoices/invoice-list',
        icon: '/svg/sidebar/receipt-item.svg',
        activeIcon: '/svg/sidebar/receipt-item-bold.svg',
        iconAlt: 'Receipt',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'manage',
        disabled: false,
    },
    {
        keyTitle: 'reports',
        url: '/reports',
        icon: '/svg/sidebar/chart.svg',
        activeIcon: '/svg/sidebar/chart-bold.svg',
        iconAlt: 'Chart',
        subMenuItems: [
            {
                keyTitle: 'absence',
                url: '/reports/absence',
                hasParams: false,
                disabled: false,
            },
            {
                keyTitle: 'timesheet',
                url: '/reports/timesheet',
                hasParams: false,
                disabled: false,
            },
            {
                keyTitle: 'finance',
                url: '/reports/finance',
                hasParams: false,
                disabled: false,
            },
        ],
        hasParams: false,
        sectionTitle: 'manage',
        disabled: false,
        showDropdown: parsedStorageState['reports'],
    },
    {
        keyTitle: 'settings',
        url: '/organization',
        icon: '/svg/sidebar/setting-2.svg',
        activeIcon: '/svg/sidebar/setting-2-bold.svg',
        iconAlt: 'Setting',
        subMenuItems: [
            {
                keyTitle: 'generalSettings',
                url: '/organization',
                hasParams: false,
            },
            {
                keyTitle: 'policies',
                url: '/policies',
                hasParams: false,
            },
            {
                keyTitle: 'branches',
                url: '/branches',
                hasParams: false,
            },
            {
                keyTitle: 'documents',
                url: '/documents',
                hasParams: false,
            },
            {
                keyTitle: 'reports',
                url: '/report-settings',
                hasParams: false,
            },
            {
                keyTitle: 'subscription',
                url: '/subscription',
                hasParams: false,
            },
        ],
        hasParams: true,
        sectionTitle: 'organization',
        disabled: false,
        showDropdown: parsedStorageState['settings'],
    },
    {
        keyTitle: 'members',
        url: '/members',
        icon: '/svg/sidebar/members.svg',
        activeIcon: '/svg/sidebar/members-bold.svg',
        iconAlt: 'Members',
        subMenuItems: [],
        hasParams: false,
        sectionTitle: 'organization',
        disabled: false,
    },
    {
        keyTitle: 'integrations',
        url: '/integrations',
        icon: '/svg/sidebar/share.svg',
        activeIcon: '/svg/sidebar/share-bold.svg',
        iconAlt: 'Organization',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'organization',
        disabled: false,
    },
    {
        keyTitle: 'teams',
        url: '/teams',
        icon: '/svg/sidebar/teams.svg',
        activeIcon: '/svg/sidebar/teams-bold.svg',
        iconAlt: 'Organization',
        subMenuItems: [],
        hasParams: true,
        sectionTitle: 'organization',
        disabled: false,
    },
    {
        keyTitle: 'performance',
        url: '/performance',
        icon: '/svg/sidebar/chart.svg',
        activeIcon: '/svg/sidebar/chart-bold.svg',
        iconAlt: 'Performance',
        subMenuItems: [
            {
                keyTitle: 'evaluation',
                url: '/evaluation',
                hasParams: false,
            },
        ],
        hasParams: true,
        sectionTitle: 'organization',
        disabled: false,
        showDropdown: parsedStorageState['performance'],
    },
];
